// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__P1Sy3","link":"footer_link__ybN0Z","bottom_link":"footer_bottom_link__wCVY4","wrap":"footer_wrap__f-xIk"};